export enum APIMethodEnum {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
}


export const apiMethodColorStyles = {
  [APIMethodEnum.GET]: "bg-[#1F6B3C]/12 text-[#1F6B3C]",
  [APIMethodEnum.POST]: "bg-blue-900/12 text-blue-900",
  [APIMethodEnum.PUT]: "bg-[#BE451E]/12 text-[#BE451E]",
  [APIMethodEnum.PATCH]: "bg-warning/12 text-warning",
  [APIMethodEnum.DELETE]: "bg-red-700/12 text-red-700",
};

export const apiMethods = [
  {
    name: APIMethodEnum.GET,
    text: "Get Data",
  },
  {
    name: APIMethodEnum.POST,
    text: "Create or Submit Data",
  },
  {
    name: APIMethodEnum.PUT,
    text: "Replace Entire Data",
  },
  {
    name: APIMethodEnum.PATCH,
    text: "Modify Partial Data",
  },
  {
    name: APIMethodEnum.DELETE,
    text: "Delete Data",
  },
];

export const httpModeColors = {
  GET: "bg-green-100 text-green-600",
  POST: "bg-blue-100 text-blue-600",
  PUT: "bg-yellow-100 text-yellow-600",
  DELETE: "bg-red-100 text-red-600",
};
